import React, { useEffect, useState } from "react";
import Axios from '../../utils/api/axiosConf';
import { url } from '../../utils/api/api';
import TABLE from '../../components/table/table'
import { FarsiDate } from "../../utils/utils"
import avatar from './../../../src/assets/images/avatar.jpg'
import { color } from "../../utils/themes/color";
import RADIO from "../../components/radio/radio";
import { Checkbox } from 'antd';
import { RedNotif, GreenNotif } from '../../utils/utils';
import BUTTON from '../../components/buttons/button';
import INPUT from "../../components/input/input";
import { Row, Col, Modal } from "antd";
import TEXTROW from "./../../components/textRow";





export default function Notification() {
    const [data, setData] = useState();
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const [loading, setLoading] = useState({ 1: false, 2: false });
    const [filter, setFilter] = useState("all");
    const [item, setItem] = useState({ title: "", description: "" });
    const [selected, setSelected] = useState([]);
    const [updater, setUpdater] = useState(1);
    const columns = [
        {
            title: 'پروفایل',
            dataIndex: 'profile',
            render: (profile) => profile != undefined ?
                profile.fileName != null ?
                    <img className="tableImage" crossOrigin="anonymous" src={`${url}${profile.path}`} />
                    : <img className="tableImage" src={avatar} />
                : <img className="tableImage" src={avatar} />,
            key: '_id',
        },
        {
            title: 'نام کامل',
            dataIndex: 'fullname',
            key: '_id',
        },
        {
            title: 'تاریخ ثبت نام',
            dataIndex: 'insertDate',
            render: (insertDate) => <p>{FarsiDate(insertDate)}</p>,
            key: '_id',
        },
        {
            title: 'موبایل',
            dataIndex: 'mobile',
            key: '_id',
        },
        {
            title: 'نوع کاربری',
            dataIndex: 'role',
            render: (role) => <p>{Role(role)}</p>,
            key: '_id',
        },
        {
            title: 'انتخاب کاربر',
            render: (e) => {
                return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        style={{
                            background: color.primary, borderRadius: "5px", paddingTop: "4px",
                            width: "70px", display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: '25px'
                        }}>
                        <div>
                            <Checkbox
                                onChange={() => {
                                    
                                    var y = 1;
                                    
                                    for (let i = 1; i == y; i++) {
                                        var x =[];
                                        x.push(e._id);
                                        y = y + 1;
                                        setSelected(x);


                                    }
                                    
                                }}

                            >
                            </Checkbox>
                        </div>

                    </div>
                </div >
            }


        },
    ];

    console.log("sel", selected);


    const filters = [{ "name": "همه", "value": "all" }, { "name": "ورزشکار", "value": "athlete" }, { "name": "مربی", "value": "coach" }];


    const Role = (R) => {
        switch (R) {
            case "athlete": return "ورزشکار"
            case "coach": return "مربی"
        }
    }

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        if (filter == "all") {
            Axios.get(`${url}users/search?limit=5&pageNumber=${page.current}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading({ ...loading, 1: false })
                    }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        } else {
            Axios.get(`${url}users/search?limit=5&pageNumber=${page.current}&role=${filter}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading({ ...loading, 1: false })
                    }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        }
    }, [page.current, filter])


    const sendNotif = () => {
        if (selected != null && selected != "" && selected != undefined) {
            setLoading({ ...loading, 2: true })
            var x = {
                title: item.title,
                description: item.description,
                userList: selected
            }
            Axios.patch(`${url}notifications/send-notif`, x)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        GreenNotif(response.message)
                        setLoading({ ...loading, 2: false })
                        setUpdater(updater + 1)
                        setItem({ title: "", description: "" })
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 2: false })

                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 2: false })

                });
        } else {
            RedNotif("لطفا حداقل یک نفر را برای ارسال اعلان انتخاب کنید")
        }
    }

    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }

    return (
        <>

            <Row >
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div className="filterUser" style={{ background: color.primary }}>
                        <p style={{ float: 'right', color: color.textColor }} >فیلتر کاربران</p>
                        <div style={{ float: "left" }}>
                            <RADIO click={(e) => { setFilter(e); setPage({ ...page, current: 1 }) }} items={filters} defaultValue={"all"} />
                        </div>
                    </div>
                    <TABLE
                        data={data}
                        columns={columns}
                        page={pager}
                        loading={loading[1]} />
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ padding: "0 50px" }} value={item.title}>
                    <p> عنوان اعلان: *</p>
                    <br />
                    <INPUT
                        i={(e) => setItem({ ...item, title: e })}
                        value={item.title} />
                    <br /><br /><br />
                    <p>متن اعلان:</p>
                    <br />
                    <TEXTROW
                        i={(e) => setItem({ ...item, description: e })}
                        value={item.description} />
                    <br />  <br />
                    <BUTTON
                        text={"ارسال اعلان"}
                        loading={loading[2]}
                        event={() => sendNotif()}
                    />

                </Col>

            </Row>
        </>
    )


}